import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './assets/css/style.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-activity/dist/library.css';
import AppRoutes from './AppRoutes';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress benign ResizeObserver loop notifications (browser quirk, not an app error).
// Registered in capture phase so we run before the CRA dev overlay's error handler.
const isResizeObserverNoise = (msg) =>
  typeof msg === 'string' &&
  (msg.includes('ResizeObserver loop completed with undelivered notifications') ||
    msg.includes('ResizeObserver loop limit exceeded'));

window.addEventListener(
  'error',
  (e) => {
    if (isResizeObserverNoise(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

window.addEventListener(
  'unhandledrejection',
  (e) => {
    if (isResizeObserverNoise(e.reason && (e.reason.message || e.reason))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>
);
